// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/preflight-inspection.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/preflight-inspection/preflight-inspection.js';

mount([g0]);
